import React from 'react';
import { useLanguage } from '@/services/languageService';
import MainLayout from '@/layouts/MainLayout';
import { Mail } from 'lucide-react';

const PrivacyPolicy = () => {
  const { t } = useLanguage();
  const formattedDate = `May 5, 2025`;

  return (
    <MainLayout>
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <h1 className="text-3xl font-bold mb-6 text-center text-purple-700">{t('privacyPolicyTitle')}</h1>
        
        <div className="prose lg:prose-lg mx-auto">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-purple-600">{t('privacyPolicyIntro')}</h2>
            <p>{t('privacyPolicyIntroContent')}</p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-purple-600">{t('privacyPolicyInformation')}</h2>
            <p>{t('privacyPolicyInformationContent')}</p>
            <ul className="list-disc pl-6 mt-3">
              <li>{t('privacyPolicyInformationItem1')}</li>
              <li>{t('privacyPolicyInformationItem2')}</li>
              <li>{t('privacyPolicyInformationItem3')}</li>
            </ul>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-purple-600">{t('privacyPolicyCookies')}</h2>
            <p>{t('privacyPolicyCookiesContent')}</p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-purple-600">{t('privacyPolicyThirdParty')}</h2>
            <p>{t('privacyPolicyThirdPartyContent')}</p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-purple-600">{t('privacyPolicySecurity')}</h2>
            <p>{t('privacyPolicySecurityContent')}</p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-purple-600">{t('privacyPolicyChanges')}</h2>
            <p>{t('privacyPolicyChangesContent')}</p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-purple-600">{t('privacyPolicyContact')}</h2>
            <p>
              {t('privacyPolicyContactContent')}
            </p>
            <div className="mt-4 flex items-center">
              <Mail className="w-5 h-5 mr-2 text-purple-600" />
              <span className="text-gray-600">{t('contactUsEmail')}: contact@randompokemon.games</span>
            </div>
          </section>
          
          <p className="text-sm text-gray-500 mt-8 text-center">
            {t('privacyPolicyLastUpdated')}: {formattedDate}
          </p>
        </div>
      </div>
    </MainLayout>
  );
};

export default PrivacyPolicy;
